<template>
  <div>
    <div class="foot-left">
      <div class="foot_link">友情链接：

        <a href="http://www.sedalink.com" target="_blank">苏州供应链</a> |

        <a href="http://www.nlineintl.com.cn" target="_blank">在线订舱</a> |

        <a href="http://www.sedalink.com" target="_blank">苏州物流公司</a> |

        <a href="http://www.scmplus.com.cn/" target="_blank">金易达供应链</a> |

        <a href="http://www.hantung.com/" target="_blank">翰棠创投</a> |

        <a href="http://www.sedalink.com" target="_blank">江苏金赛德供应链</a> |
        <a href="http://zn.sedalink.com" target="_blank">尼日利亚双清</a> |
        <a href="http://zn.sedalink.com" target="_blank">尼日利亚专线</a> 
      </div>
      <div class="foot_line"><img src="../../assets/line.png"></div>
      <div class="foot_bq">
        <div class="foot_bq_nr">版权所有©江苏金赛德供应链管理有限公司 &nbsp; <a href="https://beian.miit.gov.cn" target="_blank">苏ICP备19047531号
            <img border="0" hspace="0" vspace="0" src="http://icon.cnzz.com/img/pic.gif"> </a></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    components: {

    }
  }

</script>

<style>
  .foot-left {
    background-color: #4f4f4f;
    padding-top: 15px;
    padding-bottom: 30px;
    clear: both;
    text-align: center;
    color: #fff;
  }
.foot-left a{
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/bfooter.vue